import axios from 'axios';

const ENDPOINT = 'process';

const AXIOS_JSON = {headers: {
  'Content-Type': 'application/json',
}};

export default {
  getTree: async sitePath => {
    const url = `${sitePath}/${ENDPOINT}/tree/`;
    const response = await axios.get(url);
    return response.data;
  },

  list: async site_id => {
    const url = `${site_id}/${ENDPOINT}/`;
    const response = await axios.get(url);
    return response.data;
  },

  create: async (site_id, json) => {
    const url = `${site_id}/${ENDPOINT}/`;
    const response = await axios.post(url, JSON.stringify(json), AXIOS_JSON);
    return response.data;
  },

  update: async (site_id, process_id, json) => {
    const url = `${site_id}/${ENDPOINT}/${process_id}/`;
    const response = await axios.put(url, JSON.stringify(json), AXIOS_JSON);
    return response.data;
  },

  delete: async (site_id, process_id) => {
    const url = `${site_id}/${ENDPOINT}/${process_id}/`;
    const response = await axios.delete(url);
    return response.data;
  },
};
